const utils = {
  containsObject(obj, list) {
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i] === obj) {
        return true;
      }
    }

    return false;
  },
  formatBRL(value) {
    if (!isNaN(value)) {
      let formattedValue = value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      formattedValue = formattedValue.replace(/,/g, ';').replace('.', ',').replace(/;/g, '.');
      return formattedValue;
    }
    return value;
  },
  dateObjToString(date) {
    let paramDate = new Date(date)
    let month = '' + (paramDate.getMonth() + 1)
    let day = '' + paramDate.getDate()
    let year = paramDate.getFullYear()

    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day

    return [year, month, day].join('-');
  }
}

module.exports = utils;